import React from "react";
const InfoImage = ({ imageUrl,description }) => (
<div className="flex justify-center items-center">
        <img src={imageUrl} alt={description} />
      </div>
);

export default InfoImage;